namespace advisorop.components.servicer {

    class AdvisoryFirmCrudController {

        $router;
        lovs: Array<domains.ILOV> = [];
        selFirmType: domains.ILOV;
        showMappingPanel: boolean = false;
        selectedAdvisor: domains.IAdvisor;
        advisoryFirmId: number;
        showLabelOfSelectedCompanyGroup: boolean = false;
        //should comme from LOV !!!
        firmTypes: domains.ILOV[] = [];
        model: domains.IAdvisoryFirm;
        custodianAdvisoryFirmLink: domains.ICustodianAdvisoryFirm = {};
        custodiansWithOfficeRanges: domains.ICustodianAdvisoryFirm[] = [];
        companyGroup: domains.ICompanyGroup;
        updatingAccountLadda: boolean = false;
        companyList: Array<domains.ICompanyGroup> = [];
        streetAddressSameAsMailingAddress: boolean = false;
        flagForZipField: boolean = false;
        companyGroupId: number;
        loadedAdvisorsForLoadedAdvisoryFirm: Array<domains.IAdvisor> = [];
        loadedCompanyGroup: domains.ICompanyGroup;
        showLabel: string = 'false';
        activeTab: number = 1;
        selCompanyGroup: domains.ICompanyGroup;
        advisors: Array<domains.IAdvisor> = [];
        advisoryFirmIsCreated: boolean = false;
        states: domains.ILOV[] = [];
        countries: domains.ILOV[] = [];
        usCountryCode: string = "US";
        selStreetState: domains.ILOV;
        selMailingState: domains.ILOV;
        selStreetCountry: domains.ILOV;
        selMailingCountry: domains.ILOV;
        mappingType: domains.ExternalMappingType = domains.ExternalMappingType.ADVISORYFIRMID_TO_FIRMID;
        externalSystemDataMappings: domains.IExternalSystemDataMapping[] = [];

        selAllocationPlan: domains.ISecurityAllocationPlan;
        allocationPlans: domains.ISecurityAllocationPlan[] = [];

        // assign servicer
        selServicer: domains.IServicer;
        servicers: domains.IServicer[];
        mappingExternalSystemType = domains.ExternalSystemType.CUSTODIAN;

        user: domains.identity.IUser;
        isAServicerAdmin: boolean;


        static $inject = ["generalService", "identityService", "servicerService", "advisoryFirmApi"];
        constructor(private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            private servicerService: services.ServicerService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {
            this.model = {};
        }

        loadTestData(): void {
            /////////////////////////
            //test data ....
            this.model.streetCity = "Test City";
            this.model.advisoryFirmName = "Test company";
            this.model.contactEmail = "fehimv@gmail.com";
            this.model.contactFirstName = "First name";
            this.model.contactLastName = "Last name";
            this.model.contactPhone = "00999888";
            this.model.streetCountryId = "USA";
            this.model.streetPostCode = "XB99992";
            this.model.streetState = "WA";
            this.model.streetAddress1 = "NA";
            this.model.tin = "11122233344-12";
            this.model.firmType = 0;
        };

        validateAdvisoryFirmData(): boolean {
            if (!this.model.tin || this.model.tin.length != 9) {
                toastr.warning("Please provide 9-digit Tax ID Number.");
                return false;
            }
            if (isNaN(Number(this.model.tin))) {
                toastr.warning("Tax ID Number must consist of all numbers.");
                return false;
            }
            if (!this.model.contactPhone || this.model.contactPhone.length != 10) {
                toastr.warning("Please provide 10-digit phone number.");
                return false;
            }
            if (isNaN(Number(this.model.contactPhone))) {
                toastr.warning("Phone number must consist of all numbers.");
                return false;
            }
            return true;
        };

        createAdvisoryFirm(): void {

            if (!this.validateAdvisoryFirmData()) {
                return;
            }

            if (this.model.companyGroup.id != this.companyGroupId && this.companyGroupId > 0) {
                if (!confirm("Would you realy like to change company group for " + this.model.advisoryFirmName + " firm?"))
                    return;
            }

            let r = this.$router;
            this.model.advisors = this.advisors;
            this.updatingAccountLadda = true;
            this.model.streetAddressSameAsMailingAddress = this.streetAddressSameAsMailingAddress;

            if (this.selFirmType) {
                this.model.firmType = this.selFirmType.value;
            }

            if (this.selAllocationPlan)
                this.model.defaultAllocationPlanId = this.selAllocationPlan.id;
            else
                this.model.defaultAllocationPlanId = null;

            this.advisoryFirmApi.create(this.model)
                .then((data) => {

                    toastr.success("Advisory Firm successfully saved.");
                    this.createUpdateExternalMapping(data.data.id);
                    this.activeTab = 3;
                    this.advisoryFirmIsCreated = true;
                    this.loadAdvisoryFirm(data.data.id);
                })
                .catch((error) => {
                    toastr.error("Adivsory firm was not registered! " + error.status + " : " + error.data);
                }).
                finally(() => {
                    this.updatingAccountLadda = false;
                });
        }

        newCompanyGroupSelected(companyGroup: domains.ICompanyGroup): void {
            if (companyGroup != null) {
                if (this.model.id > 0 && this.loadedCompanyGroup.id != companyGroup.id) {
                    this.advisors = [];
                    this.model.companyGroup = companyGroup;
                    this.companyGroupId = companyGroup.id;
                }
            }

            if (companyGroup == null) {
                this.model.companyGroup = null;
                this.advisors = [];
                toastr.warning("Please update the company group for this advisory firm.");
                return null;
            }
            else {
                this.model.companyGroup = companyGroup;
                this.companyGroupId = companyGroup.id;
            }
        };


        newAdvisorSelected(advisor: domains.IAdvisor): void {
            var adv = this.advisors.filter((v, i, a) => {
                return v.id == advisor.id;
            });
            if (adv.length === 0)
                this.advisors.push(advisor);
            else
                toastr.warning("This advisor already exists in the list of advisors.");

        };

        removeAdvisorFromAdvisors(advisor: domains.IAdvisor): void {
            var ind = this.advisors.indexOf(advisor);
            if (ind >= 0)
                this.advisors.splice(ind, 1);
        };


        loadAdvisoryFirm(id: number): void {
            this.advisoryFirmApi.getById(id).then(data => {
                this.model = data.data;

                if (!this.model.servicers)
                    this.model.servicers = [];

                this.loadedAdvisorsForLoadedAdvisoryFirm = data.data.advisors;
                this.loadedCompanyGroup = data.data.companyGroup;
                this.advisoryFirmId = this.model.id;
                this.showLabel = 'true';
                this.selFirmType = <domains.ILOV>{ value: this.model.firmType };
                this.selStreetState = <domains.ILOV>{ extra1: this.model.streetState };
                this.selMailingState = <domains.ILOV>{ extra1: this.model.mailingState };
                this.selStreetCountry = <domains.ILOV>{ extra2: this.model.streetCountryId };
                this.selMailingCountry = <domains.ILOV>{ extra2: this.model.mailingCountryId };
                this.streetAddressSameAsMailingAddress = this.model.streetAddressSameAsMailingAddress;
                this.companyGroupId = data.data.companyGroup.id;
                this.advisors = data.data.advisors;

                this.custodiansWithOfficeRanges = this.model.custodians?.filter(v => { return v.custodian.hasOfficeRanges; });

                this.servicerService.getSecurityAllocationPlans(id)
                    .then(response => {
                        this.allocationPlans = response.data;
                        if (this.model.defaultAllocationPlanId > 0)
                            this.selAllocationPlan = this.allocationPlans.filter(f => f.id == this.model.defaultAllocationPlanId)[0];
                    },
                        err => toastr.error("Error occured during allocation plans loading. ERROR: " + err.status + " " + err.data));

                // loading servicers assigned to the firm
                this.servicerService.getServicersAssignedToFirm(this.advisoryFirmId).then(response => {
                    this.model.servicers = response.data;
                }, err => this.generalService.showError(err));

            });
        }

        //calbacks from Custodian - Advisory Firm Map
        onCustodianAdvisoryFirmCreated(custodianAdvisoryFirm: domains.ICustodianAdvisoryFirm): void {
            if (custodianAdvisoryFirm)
                this.model.custodians.push(custodianAdvisoryFirm);
            this.loadAdvisoryFirm(this.model.id);
            this.showMappingPanel = false;
        };
        onCustodianAdvisoryFirmModified(custodianAdvisoryFirm: domains.ICustodianAdvisoryFirm): void {
            let ind = this.model.custodians.map(m => { return m.id; }).indexOf(custodianAdvisoryFirm.id);
            if (ind >= 0)
                angular.copy(custodianAdvisoryFirm, this.model.custodians[ind]);
            this.showMappingPanel = false;
        };
        onCustodianAdvisoryFirmDeleted(custodianAdvisoryFirmLinkId: number): void {
            let ind = this.model.custodians.map(m => { return m.id; }).indexOf(custodianAdvisoryFirmLinkId);
            if (ind >= 0)
                this.model.custodians.splice(ind, 1);
            this.showMappingPanel = false;
        };
        //////////////////

        editCustodianAdvisoryFirmLink(custodianAdvisoryFirmLink: domains.ICustodianAdvisoryFirm) {
            if (custodianAdvisoryFirmLink) {
                this.custodianAdvisoryFirmLink = {};
                angular.copy(custodianAdvisoryFirmLink, this.custodianAdvisoryFirmLink);
                this.showMappingPanel = true;
            }
            else {
                this.custodianAdvisoryFirmLink = {};
            }
        }

        createUpdateExternalMapping(id: number) {
            if (this.externalSystemDataMappings.length > 0) {
                for (var i = 0; i < this.externalSystemDataMappings.length; i++) {
                    if (this.externalSystemDataMappings[i].advisorOpDataFieldId == 0)
                        this.externalSystemDataMappings[i].advisorOpDataFieldId = id;
                }

                this.servicerService.createUpdateExternalSystemDataMappings(this.externalSystemDataMappings).then(data => {

                }).catch(err => {

                });
            }
        }

        //externalMappingChanged(data: domains.IExternalSystemDataMapping[]) {
        //    this.externalSystemDataMappings = data;

        //    console.log("externalSystemDataMappings", data);
        //}


        streetAddressChanged(): void {
            if (this.selStreetState)
                this.model.streetState = this.selStreetState.extra1;
            if (this.selStreetCountry)
                this.model.streetCountryId = this.selStreetCountry.extra2;
            if (this.streetAddressSameAsMailingAddress == true) {
                this.selMailingCountry = this.selStreetCountry;
                this.selMailingState = this.selStreetState;
                this.model.mailingAddress1 = this.model.streetAddress1;
                this.model.mailingAddress2 = this.model.streetAddress2;
                this.model.mailingCity = this.model.streetCity;
                this.model.mailingCountryId = this.model.streetCountryId;
                this.model.mailingPostCode = this.model.streetPostCode
                this.model.mailingState = this.model.streetState;
            } else {
                if (this.selMailingState)
                    this.model.mailingState = this.selMailingState.extra1;
                if (this.selMailingCountry)
                    this.model.mailingCountryId = this.selMailingCountry.extra2;
            }
        }

        equalsAddresses(): void {
            this.streetAddressSameAsMailingAddress = !this.streetAddressSameAsMailingAddress;
            this.flagForZipField = !this.flagForZipField;
            this.selMailingCountry = this.selStreetCountry;
            this.selMailingState = this.selStreetState;
            this.model.mailingAddress1 = this.model.streetAddress1;
            this.model.mailingAddress2 = this.model.streetAddress2;
            this.model.mailingCity = this.model.streetCity;
            this.model.mailingCountryId = this.model.streetCountryId;
            this.model.mailingPostCode = this.model.streetPostCode
            this.model.mailingState = this.model.streetState;
        }

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {
                    this.lovs = data;
                    this.firmTypes = this.lovs.filter(v => v.lovType === domains.LovType.FIRM_TYPE && v.extra1 == "A");
                    this.states = this.lovs.filter(v => v.lovType === domains.LovType.STATES);
                    this.countries = this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 === this.usCountryCode)
                        .concat(this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 !== this.usCountryCode));
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        logout(): void {
            this.identityService.logout();
        }

        loadServicers() {
            this.servicerService.getServicers()
                .then(resp => {
                    this.servicers = resp.data;
                }, err => this.generalService.showError(err));
        };
        searchServicer(searchTerm: string) {
            searchTerm = searchTerm.toLowerCase();
            // for tuning:
            // we need to exclude already assigned servicers and SERVICER_ADMINs 
            return this.servicers.filter(f => f.firstName.toLowerCase().indexOf(searchTerm) >= 0
                || f.lastName.toLowerCase().indexOf(searchTerm) >= 0);
        }
        linkServicer() {
            toastr.info(`Linking servicer... ${this.selServicer.firstName} (${this.selServicer.role})`);
            if (this.model.servicers.indexOf(this.selServicer) < 0) {
                this.servicerService.assignAdvisoryFirmToServicer({
                    advisoryFirmId: this.advisoryFirmId,
                    servicerId: this.selServicer.id,
                    id: 0
                }).then(resp => {
                    toastr.success(`Servicer has been successfully assigned to the advisory firm`);
                    this.model.servicers.push({ ...this.selServicer });
                    this.selServicer = null;
                }, err => this.generalService.showError(err));
            }
        }
        unlinkServicer(servicer: domains.IServicer) {
            toastr.info(`Unlinking servicer... ${servicer.firstName} (${servicer.role})`);
            this.servicerService.unassignAdvisoryFirmFromServicer(this.advisoryFirmId,
                servicer.id).then(resp => {
                    toastr.success(`Servicer has been successfully unassigned from the advisory firm`);
                    const ind = this.model.servicers.indexOf(servicer);
                    if (ind >= 0) {
                        this.model.servicers.splice(ind, 1);
                    }
                }, err => this.generalService.showError(err));
        }

        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.isAServicerAdmin = (this.user.role == domains.AdvisoryRoles.SERVICER_ADMIN.toString());
                if (!this.isAServicerAdmin)
                    this.activeTab = 5;
            });

            this.loadLovs();
            this.loadCompanyGroupList();
            this.loadServicers();
        }

        loadCompanyGroupList(): void {
            this.servicerService.getCompanyGroups()
                .then(data => {
                    this.companyList = data.data;
                })
                .catch(err => {
                    toastr.error("Cannot fetch advisory firm list.");
                })
        };

        $routerOnActivate(next, previous) {
            if (next.params.id) {
                this.loadAdvisoryFirm(<number>next.params.id);
            }
        }
    }


    class AdvisoryFirmCrud implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AdvisoryFirmCrudController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/advisory-firm-crud.html';
        }
    }
    angular.module(Constants.APP).component("advisoryFirmCrud", new AdvisoryFirmCrud());
}
